export {}; // Ensure this file is treated as a module

declare global {
    interface Number {
        toCurrencyFormat(currencyCode?: string): string;
        unformatCurrency(): number | null; // Added unformatCurrency to the interface
    }
}

Number.prototype.toCurrencyFormat = function (currencyCode = 'ZAR'): string {
    return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(Number(this));
};

Number.prototype.unformatCurrency = function (): number | null {
    const value = this.toString();
    if (!value || typeof value !== 'string') {
        return null;
    }

    const numericValue = value.replace(/[^0-9.-]+/g, '');
    const parsedValue = parseFloat(numericValue);

    return isNaN(parsedValue) ? null : parsedValue;
};